import { LoyaltyProgramCapabilityModel } from '@rd/types/loyalty-program-capability.model';
import { LoyaltyProgramCapability } from '@rd/types/loyalty-program-capability.type';
import { isValidUrl } from '@rd/utils/url.utils';

export function loyaltyProgramCapabilitySerializer(
  model: LoyaltyProgramCapabilityModel,
): LoyaltyProgramCapability {
  const { enrollmentUrl, conditionsUrl, detailsUrl, logoUrl } =
    model.attributes;
  return {
    id: model.id,
    ...model.attributes,
    // @ts-ignore
    conditionsUrl: isValidUrl(conditionsUrl) ? new URL(conditionsUrl) : null,
    // @ts-ignore
    enrollmentUrl: isValidUrl(enrollmentUrl) ? new URL(enrollmentUrl) : null,
    // @ts-ignore
    detailsUrl: isValidUrl(detailsUrl) ? new URL(detailsUrl) : null,
    // @ts-ignore
    logoUrl: isValidUrl(logoUrl) ? new URL(logoUrl) : null,
  };
}
